import { useParams } from 'react-router'
import { useObjectActionMutation, useObjectGet } from '../api/object'
import { Button } from '../components/button'
import { Dialog } from '../components/dialog'
import { usePageLayout } from '../layouts'
import { PageLayout } from '../layouts/page-layout'
import { useToggle } from '../use-toggle'
import { Accept } from './accept'
import { Alternative } from './alternative'
import { ProposalItems } from './proposal-items'

export function Base() {
	const { proposalId = '' } = useParams()
	const { data: proposal } = useObjectGet('proposal', proposalId)
	const { layout: pageLayout } = usePageLayout('proposal')
	const { mutate: refuse } = useObjectActionMutation('proposal', proposalId, 'refuse')
	const { mutate: refuseElsewhere } = useObjectActionMutation(
		'proposal',
		proposalId,
		'refuse-elsewhere',
	)
	const { mutate: cancel } = useObjectActionMutation('proposal', proposalId, 'cancel')
	const [isCancelling, toggleIsCancelling] = useToggle()
	const [isAlternative, toggleIsAlternative] = useToggle()
	const [isAccepting, toggleIsAccepting] = useToggle()

	return (
		<section className="container m-auto">
			<div className="flex justify-between gap-4 p-4">
				<h3 className="text-md font-bold">
					Poptávka <span className="text-gray-600 font-normal">ID: {proposalId}</span>
				</h3>
				<div className="flex gap-4">
					{proposal?.status === 'new' ? (
						<>
							{proposal.proposal_vehicle_id ? (
								<Button variant="PRIMARY" onPress={toggleIsAccepting}>
									Přijmout
								</Button>
							) : null}
							<Button variant="SECONDARY" onPress={() => refuse(undefined)}>
								Fuck&nbsp;off
							</Button>
							<Button variant="SECONDARY" onPress={() => refuseElsewhere(undefined)}>
								Řešeno jinde/Fuck off
							</Button>
							<Button variant="SECONDARY" onPress={toggleIsAlternative}>
								Alternativní nabídka
							</Button>
						</>
					) : null}
					{proposal?.status === 'refused' || proposal?.status === 'refused_elsewhere' ? (
						<>
							<Button variant="PRIMARY" onPress={toggleIsAlternative}>
								Alternativní nabídka
							</Button>
							{proposal.proposal_vehicle_id ? (
								<Button variant="SECONDARY" onPress={toggleIsAccepting}>
									Přijmout
								</Button>
							) : null}
							<Button variant="DANGER" onPress={toggleIsCancelling}>
								Zrušit
							</Button>
						</>
					) : null}
					{proposal?.status === 'alternative' ? (
						<div className="flex gap-3">
							{proposal.proposal_vehicle_id ? (
								<Button variant="SECONDARY" onPress={toggleIsAccepting}>
									Přijmout
								</Button>
							) : null}
							<Button variant="DANGER" onPress={toggleIsCancelling}>
								Zrušit
							</Button>
						</div>
					) : null}
				</div>
			</div>
			{pageLayout ? (
				<PageLayout object="proposal" id={proposalId} data={proposal} layout={pageLayout}>
					<ProposalItems proposalId={proposalId} />
				</PageLayout>
			) : null}
			{isCancelling ? (
				<Dialog heading="Zrušit poptávku" isOpen onOpenChange={toggleIsCancelling}>
					<div className="m-4">
						<p>Opravdu chcete zrušit poptávku?</p>
					</div>
					<div className="flex justify-between gap-4 m-4">
						<Button
							variant="DANGER"
							onPress={() => {
								cancel(undefined, {
									onSuccess() {
										toggleIsCancelling(false)
									},
								})
							}}
						>
							Ano
						</Button>
						<Button variant="SECONDARY" onPress={toggleIsCancelling}>
							Ne
						</Button>
					</div>
				</Dialog>
			) : null}
			{isAccepting ? <Accept onClose={toggleIsAccepting} proposal={proposal!} /> : null}
			{isAlternative ? (
				<Alternative onClose={toggleIsAlternative} proposalId={proposalId} />
			) : null}
		</section>
	)
}
